import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TermsService } from '../../services/terms.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.html',
  styleUrls: ['./cookies.scss']
})
export class cookies implements OnInit, OnDestroy {
  termsText: string;
  private langSub: Subscription;

  constructor(
    private dialogRef: MatDialogRef<cookies>,
    private termsService: TermsService,
    private translate: TranslateService
  ) {
    this.termsText = this.termsService.getTermsText();
  }

  ngOnInit(): void {
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.termsText = this.termsService.getTermsText();
    });
  }

  approve() {
    this.dialogRef.close({ approve: true });
  }

  close() {
    this.dialogRef.close({ approve: false });
  }

  ngOnDestroy(): void {
    if (this.langSub) { this.langSub.unsubscribe(); }
  }
}
